<template>
    <div>
		about
    </div>
</template>




<script>


export default {
	
}
</script>

<style lang="sass">



</style>



// WEBPACK FOOTER //
// src/About.vue